var React = require('react');

function AlertCross (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#00121A","fillRule":"nonzero"},[React.createElement("path",{"d":"M5.293 6.707l1.414-1.414 12 12-1.414 1.414z","key":0}),React.createElement("path",{"d":"M6.707 18.707l-1.414-1.414 12-12 1.414 1.414z","key":1})]));
}

AlertCross.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = AlertCross;

AlertCross.default = AlertCross;
